module.exports = __webpack_public_path__ + "img/180.main_courses.8e961d1d.svg";